import { render, staticRenderFns } from "./vehiclePrice.vue?vue&type=template&id=d58c1b42&scoped=true"
import script from "./vehiclePrice.vue?vue&type=script&lang=js"
export * from "./vehiclePrice.vue?vue&type=script&lang=js"
import style0 from "./vehiclePrice.vue?vue&type=style&index=0&id=d58c1b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58c1b42",
  null
  
)

export default component.exports